import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api.service';
import { IccIneligibleDrugImport } from '../../models/icc/icc-ineligible-drug-import.model';
import { IccImportFilters } from '../../models/icc/icc-import-settings.model';
import { LimitOffsetPagingMeta } from 'app/core/models/paged-results/limit-offset-paging.model';
import { PagedResults } from 'app/core/models/paged-results/paged-results.model';

export class PagedIccIneligibleDrugImports implements PagedResults {
  ineligibleDrugImports: IccIneligibleDrugImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.ineligibleDrugImports;
  }
}

@Injectable()
export class IccIneligibleDrugImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<IccIneligibleDrugImport> {
    return this.http.get<IccIneligibleDrugImport>(`${environment.captureApi.url}/icc/ineligible_drug_imports/${id}`);
  }

  getList(
    paging: { page: number; pageSize: number } = null,
    filters: IccImportFilters = null
  ): Observable<PagedIccIneligibleDrugImports> {
    const params = new URLSearchParams();

    if (filters && filters.selectedClientIds) {
      filters.selectedClientIds.forEach(clientId => params.append('client_ids[]', clientId));
    }

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedIccIneligibleDrugImports>(
      `${environment.captureApi.url}/icc/ineligible_drug_imports?${params.toString()}`
    );
  }

  create(clientId: number, name: string, signedId: string): Observable<IccIneligibleDrugImport> {
    return this.http.post<IccIneligibleDrugImport>(`${environment.captureApi.url}/icc/ineligible_drug_imports`, {
      ineligibleDrugImport: { clientId, name, signedId },
    });
  }

  update(id, name): Observable<IccIneligibleDrugImport> {
    return this.http.put<IccIneligibleDrugImport>(`${environment.captureApi.url}/icc/ineligible_drug_imports/${id}`, {
      ineligibleDrugImport: { name },
    });
  }

  cancel(id): Observable<IccIneligibleDrugImport> {
    return this.http.patch<IccIneligibleDrugImport>(
      `${environment.captureApi.url}/icc/ineligible_drug_imports/${id}/cancel`,
      {}
    );
  }
}
